import { Button, Flex, Text } from 'pcln-design-system';
import React from 'react';
import { MapIcon } from '../Maps/SinglePinIcon';
import { mapPinType } from '../../constants';
export const InlineLocationLink = props => {
  const {
    pinsInCurrentLine,
    googlePinMeta,
    handleMapButtonClick,
    metadata
  } = props;
  return React.createElement(Button, {
    variation: 'link',
    style: {
      transform: 'translateY(5px)'
    },
    onClick: function (event) {
      event.stopPropagation();
      event.preventDefault();
      handleMapButtonClick(pinsInCurrentLine, googlePinMeta);
    }
  }, React.createElement(Flex, {
    alignItems: 'center'
  }, MapIcon({
    type: metadata === null || metadata === void 0 ? void 0 : metadata.type,
    iconProp: {
      color: 'primary',
      size: 20
    }
  }), React.createElement(Text.span, {
    fontSize: 2,
    ml: 1,
    bold: metadata.type === mapPinType.HOTEL ? true : false
  }, metadata.name)));
};